(function () {
  'use strict';
  // The tool cards are plain links with still previews; only the quick round
  // needs script. It keeps the best result hidden until the visitor picks.
  const game = document.querySelector('[data-game-preview]');
  if (game) {
    const choices = [...game.querySelectorAll('[data-game-offer]')];
    const reset = game.querySelector('[data-game-reset]');
    const feedback = game.querySelector('[data-game-feedback]');
    const explanation = game.querySelector('[data-game-explanation]');
    const result = game.querySelector('#td-game-result');
    const score = game.querySelector('[data-game-you-kept]');
    const buyers = game.querySelector('[data-game-you-buyers]');
    const best = game.querySelector('[data-game-best-kept]');
    const bestDetail = game.querySelector('[data-game-best-detail]');
    const math = game.querySelector('[data-game-math]');
    const icon = game.querySelector('[data-game-verdict-icon]');
    const start = [feedback, explanation, buyers, score, best, bestDetail, icon].map(node => [node, node.textContent]);
    let feedbackMotion;
    choices.forEach(choice => {
      choice.disabled = false;
      choice.addEventListener('click', () => {
        const found = choice.dataset.gameChoiceOutcome === 'best';
        game.dataset.gameRevealed = 'true';
        game.dataset.gameOutcome = choice.dataset.gameChoiceOutcome;
        choices.forEach(option => {
          const selected = option === choice;
          option.setAttribute('aria-pressed', String(selected));
          option.querySelector('[data-game-pick]').textContent = selected ? '✓ Your pick' : 'Try this →';
        });
        score.textContent = choice.dataset.gameKept;
        buyers.textContent = choice.dataset.gameBuyers;
        best.textContent = best.dataset.reveal;
        bestDetail.textContent = bestDetail.dataset.reveal;
        feedback.textContent = choice.dataset.gameVerdict;
        explanation.textContent = choice.dataset.gameReason;
        math.textContent = choice.dataset.gameCalculation;
        icon.textContent = found ? '✓' : '↑';
        reset.hidden = false;
        // Feedback is immediate. Motion only draws attention to the new score.
        const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        feedbackMotion?.cancel();
        if (!reducedMotion && result.animate) {
          feedbackMotion = result.animate([{ opacity: .65, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 200, easing: 'ease-out' });
        }
        // On short screens, reveal the result without moving keyboard focus.
        const bounds = result.getBoundingClientRect();
        if (bounds.bottom > window.innerHeight - 16 && bounds.top > 0) {
          result.scrollIntoView?.({ block: 'nearest', behavior: reducedMotion ? 'instant' : 'smooth' });
        }
      });
    });
    reset.addEventListener('click', () => {
      feedbackMotion?.cancel();
      game.dataset.gameRevealed = 'false';
      game.dataset.gameOutcome = 'idle';
      choices.forEach(choice => {
        choice.setAttribute('aria-pressed', 'false');
        choice.querySelector('[data-game-pick]').textContent = 'Pick this →';
      });
      start.forEach(([node, text]) => { node.textContent = text; });
      math.textContent = '';
      reset.hidden = true;
      choices[0].focus({ preventScroll: true });
      // On a short phone screen the offers can end up under the sticky header
      // once the result collapses; bring them back into view (scroll-margin in
      // tools-directory.css keeps them clear of the header).
      choices[0].scrollIntoView({ block: 'nearest' });
    });
  }
})();
